module.exports = __webpack_public_path__ + "img/IMG_2729_L_BlackMatted_MockedUp.6eb0191b.jpg";